import React, { useEffect, useState } from "react";
import { Player } from "video-react";
import { IP } from "../../../../internalServer";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";

export default function SubmisshionByUpload({
  response,
  questionNo,
  isAdaptiveCheck,
  showEvaluationCriteria, // <--- Prop from parent
}) {
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({ pdfView: false });
  const [isClicked, setIsClicked] = useState(false);
  const [answerLimit, setAnswerLimit] = useState(
    response?.question_response?.question?.type?.maxLimit || 2500,
  );

  useEffect(() => {
    setAnswerLimit(response?.question_response?.question?.type?.maxLimit);
  }, [response?.question_response?.question?.type]);

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleRemovePdfVivwer = () =>
    setPedingSubDetail({ ...pedingSubDetail, pdfView: false });

  // Feedback priority logic
  const teacherComment = response?.teacher_comment || response?.comment;
  const displayFeedback = teacherComment || response?.evaluation_explanation;

  return (
    <>
      <div className="containerBelowQuestion">
        {/* Title */}
        <div className="mb-5">
          <div className="text-[16px] font-semibold text-slate-800 leading-relaxed">
            Q{questionNo}.{" "}
            {response?.question_response?.question?.title
              ?.split("\n")
              .map((line, index) => (
                <React.Fragment key={index}>
                  {index !== 0 && <br />}
                  <span
                    style={
                      index !== 0
                        ? { marginLeft: "30px", display: "inline-block" }
                        : {}
                    }
                  >
                    {line}
                  </span>
                </React.Fragment>
              ))}
            {response?.question_response?.question?.is_mandatory && (
              <span className="inline-block ml-3 px-2 py-0.5 rounded bg-red-50 text-red-700 text-[10px] font-bold uppercase tracking-wide border border-red-200">
                * Mandatory
              </span>
            )}
          </div>
        </div>

        {/* Student Answer Label */}
        <div className="text-[12px] font-bold text-slate-500 uppercase tracking-wide mb-2">
          Student's Answer
        </div>

        {response?.question_response?.description && (
          <div className="relative mb-4">
            <textarea
              readOnly
              className="w-full p-4 rounded-xl border border-slate-200 bg-slate-50 text-slate-700 text-sm leading-relaxed focus:outline-none"
              maxLength={answerLimit}
              value={response?.question_response?.description}
              style={{ height: "160px", resize: "none" }}
            />
            <div className="absolute bottom-3 right-4 text-[11px] font-semibold text-slate-400">
              {response?.question_response?.description?.length}/{answerLimit}
            </div>
          </div>
        )}

        {/* ============================================================
            AGAR showEvaluationCriteria TRUE HAI -> NAYA CRITERIA UI
           ============================================================ */}
        {showEvaluationCriteria && (
          <div className="mt-6 bg-white rounded-xl border border-slate-200 p-5 shadow-sm">
            {/* AI Feedback Header */}
            <div className="flex items-center gap-2 mb-3">
              <div className="bg-purple-100 text-purple-600 p-1.5 rounded-lg">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                </svg>
              </div>
              <h3 className="text-[15px] font-bold text-slate-800 m-0">
                AI Feedback
              </h3>
            </div>

            {/* Tags - Only AI Evaluated */}
            <div className="flex flex-wrap items-center gap-2 mb-4">
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-indigo-50 text-indigo-700 text-[11px] font-semibold border border-indigo-100">
                <span className="w-1.5 h-1.5 rounded-full bg-indigo-500" /> AI
                Evaluated
              </span>
            </div>

            {/* Feedback Text */}
            {displayFeedback && (
              <div className="bg-slate-50 rounded-lg p-4 mb-6 border border-slate-100 text-[13.5px] leading-relaxed text-slate-700">
                {displayFeedback}
              </div>
            )}

            {/* Evaluation Criteria List */}
            {response?.evaluation_criteria?.length > 0 && (
              <div>
                <h4 className="text-[13px] font-semibold text-slate-500 uppercase tracking-wider mb-3">
                  Evaluation Criteria
                </h4>
                <div className="flex flex-col gap-3">
                  {response.evaluation_criteria.map((criteria, idx) => {
                    const isPassed = criteria.marks > 0;
                    return (
                      <div
                        key={criteria._id || idx}
                        className="border border-slate-200 rounded-lg p-3.5 bg-white"
                      >
                        <div className="flex justify-between items-start gap-3">
                          <div className="flex items-start gap-2.5">
                            {/* Icon */}
                            <div
                              className={`mt-0.5 shrink-0 ${
                                isPassed ? "text-emerald-500" : "text-red-500"
                              }`}
                            >
                              {isPassed ? (
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                  <polyline points="22 4 12 14.01 9 11.01" />
                                </svg>
                              ) : (
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <circle cx="12" cy="12" r="10" />
                                  <line x1="15" y1="9" x2="9" y2="15" />
                                  <line x1="9" y1="9" x2="15" y2="15" />
                                </svg>
                              )}
                            </div>
                            {/* Title + Justification */}
                            <div>
                              <p className="text-[13.5px] font-semibold text-slate-800 m-0 leading-tight">
                                {criteria.criterion}
                              </p>
                              {criteria.justification && (
                                <p className="text-[12.5px] text-slate-500 mt-1.5 m-0 leading-snug">
                                  {criteria.justification}
                                </p>
                              )}
                            </div>
                          </div>
                          {/* Marks badge */}
                          <span
                            className={`shrink-0 px-2 py-1 rounded text-[11px] font-bold ${
                              isPassed
                                ? "bg-emerald-50 text-emerald-700"
                                : "bg-red-50 text-red-700"
                            }`}
                          >
                            {criteria.marks}/{response.max_marks ?? 0}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ============================================================
            AGAR showEvaluationCriteria FALSE / undefined HAI -> PURANA UX
           ============================================================ */}
        {!showEvaluationCriteria && !isAdaptiveCheck && (
          <div className="mt-6 p-4 rounded-xl bg-slate-50 border border-slate-200">
            <div className="flex items-center gap-2 mb-2">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                className="text-indigo-500"
              >
                <path
                  d="M12 2L14.5 9H21L15.5 13L17.5 20L12 16L6.5 20L8.5 13L3 9H9.5L12 2Z"
                  fill="currentColor"
                  opacity="0.2"
                />
                <path
                  d="M12 2L14.5 9H21L15.5 13L17.5 20L12 16L6.5 20L8.5 13L3 9H9.5L12 2Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-[11px] font-bold text-indigo-600 uppercase tracking-wider">
                Evaluation Comment
              </span>
            </div>
            <div className="text-sm text-slate-700 leading-relaxed">
              {displayFeedback || "No evaluation comment available."}
            </div>
          </div>
        )}

        {/* Correct Answer Explanation */}
        {response?.question_response?.question?.correct_answers?.length > 0 &&
          response?.question_response?.question?.correct_answers?.map(
            (correctAnswer, index) => {
              const explanation = correctAnswer?.reason_for_answer?.explanation;
              return (
                <div key={index} className="mt-6">
                  <div className="flex items-center gap-2 mb-2">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="text-emerald-500"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="9"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />
                      <path
                        d="M8 12L11 15L16 9"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="text-[11px] font-bold text-emerald-600 uppercase tracking-wider">
                      Correct Answer
                    </span>
                  </div>
                  <div className="text-sm text-slate-700 leading-relaxed bg-emerald-50/50 border border-emerald-100 p-3 rounded-lg">
                    {explanation || "No Explanation"}
                  </div>
                </div>
              );
            },
          )}
      </div>

      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}

      {isClicked &&
        responseAttach &&
        (responseAttach.split(".").pop().toLowerCase() === "mp4" ? (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              <Player
                className="videoPlayer"
                src={IP + responseAttach.replace(/^\./, "")}
              />
              <div>
                <img
                  className="crossIconImgQue cursor-pointer"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Close"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={() => setIsError(true)}
                  />
                  <div>
                    <img
                      className="crossIconImgQue cursor-pointer"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Close"
                    />
                  </div>
                </>
              ) : (
                <div className="fullSizeImg flex flex-col items-center justify-center">
                  <img
                    onClick={() => {
                      setIsError(false);
                      handleClick();
                    }}
                    src="/images/cross.png"
                    alt="Close"
                    className="cursor-pointer absolute top-[75px] right-[40%]"
                  />
                  <img
                    src="/images/no-photo1.png"
                    alt="img"
                    className="w-1/4"
                  />
                  <p className="text-red-500 text-lg font-medium mt-4">
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  );
}
